


import group2Api from '@/apis/group2';
import { AdminGroup2 } from '@/models/apis/group2/adminGroup2Response';
import { AdminListTableField } from '@/types/adminListTable';
import { defineComponent, onMounted, reactive } from '@vue/composition-api';

interface AdminGroup2State {
  groups2: AdminGroup2[];
}

export default defineComponent({
  name: 'admin-groups2',
  setup() {
    const state = reactive<AdminGroup2State>({
      groups2: [],
    });

    const fields: AdminListTableField[] = [
      { name: 'name', label: '事業所名' },
      { name: 'disp_order', label: '表示順' },
    ];

    const canEditRow = () => false;
    const canDeleteRow = () => false;

    const loadGroups = async() => {
      state.groups2 = [];
      const { data } = await group2Api.adminIndex();
      if (!data || data.length === 0) return;
      state.groups2 = data;
    };
    onMounted(async() => {
      await loadGroups();
    });

    return {
      state,
      fields,
      canEditRow,
      canDeleteRow,
      loadGroups,
    };
  },
});
